jQuery(document).ready(function($) {
    
	$('.js-carousel-featuredhero').slick({
		autoplay: true,
		dots: false,
		arrows: false,
		fade: true,
		speed: 1000
	});
    
	$('.js-carousel-testimonials').slick({
		autoplay: false,
		dots: false,
		arrows: true,
		fade: true,
		prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="/wp-content/themes/aroma/lib/images/testimonial-carousel-chevron.svg"> Previous</button>',
		nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next <img src="/wp-content/themes/aroma/lib/images/testimonial-carousel-chevron.svg"></button>'
	});
    
	$('.js-carousel-logo').slick({
		autoplay: true,
		dots: false,
		arrows: false,
		slidesToShow: 10,
		slidesToScroll: 1,
		speed: 750,
		pauseOnHover: false,
		responsive: [
		    {
		      	breakpoint: 992,
		      	settings: {
		        	slidesToShow: 5,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 500,
		      	settings: {
		        	slidesToShow: 3,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});
 
});
